module.exports = __webpack_public_path__ + "img/instagram.15bc5470.svg";